var map = {
	"./": "./src/config/index.js",
	"./dev": "./src/config/dev.js",
	"./dev.js": "./src/config/dev.js",
	"./index": "./src/config/index.js",
	"./index.js": "./src/config/index.js",
	"./prod": "./src/config/prod.js",
	"./prod.js": "./src/config/prod.js",
	"./test": "./src/config/test.js",
	"./test.js": "./src/config/test.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/config sync recursive ^\\.\\/.*$";